import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Translate} from "../../../../config/Translate";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {connect} from "trim-redux";
import TextField from "@material-ui/core/TextField/TextField";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton/IconButton";
import MessageRoundedIcon from '@material-ui/icons/MessageRounded';
import {theme} from "../../../../config/design/theme";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import Typography from "@material-ui/core/Typography/Typography";
import validator from "validator";
import EditRoundedIcon from '@material-ui/icons/EditRounded';
class ChangeMobileModal extends React.Component{
    state = {
        open: false,
        loading:true,
        submit_loading:false,
        error:false,
        mobile:'',
    };
    toggleOpen(){
        this.setState({
            open: !this.state.open
        })
    }
    handleSend(redirect = false){
        this.setState({
            submit_loading:true
        })
        let{mobile} = this.state;
        if(!validator.isNumeric(mobile) || mobile.length !== 11){
           this.setState({
               error: Translate.wrongMobile
           })
        }else{
            let data = new FormData();
            data.append('mobile', mobile);
            let loginToken = localStorage.getItem('ACT');
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            axios.post(`${defaultVariabls.url}/user/changeMobile`, data, config)
                .then(response => {
                    this.setState({
                        open: false,
                        loading:false,
                        submit_loading:false,
                        error:false,
                    });
                    window.location.reload();
                })
                .catch(error => {
                    if(!!error.response){
                        if(error.response.status === 403){
                            this.props.enqueueSnackbar(Translate.existMobile, {
                                variant: 'error',
                            });
                        }else{
                            this.props.enqueueSnackbar(Translate.dataAddingFailed, {
                                variant: 'error',
                            });
                        }
                    }else{
                        this.props.enqueueSnackbar(Translate.dataAddingFailed, {
                            variant: 'error',
                        });
                    }
                    this.setState({
                        submit_loading:false,
                    });
                });
        }
    }
    render(){
        let {mobile,submit_loading,open} = this.state;
        let {user} = this.props;
        return (
            <>
                <Button
                    size="small"
                    color="primary"
                    onClick={() => this.toggleOpen()}
                >
                    {Translate.editMobile}
                </Button>
                <Dialog
                    open={open}
                    onClose={() => this.toggleOpen()}
                    aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth="xs"
                >
                    <DialogTitle id="form-dialog-title">
                        <IconButton
                            onClick={() => this.toggleOpen()}
                            style={{position:"absolute",left:15,top:15}}
                            size="small"
                        >
                            <CloseRoundedIcon fontSize="small"/>
                        </IconButton>
                        {Translate.editMobile}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Typography paragraph>
                                {Translate.editMobileDesc}
                                {user.mobile}
                                {Translate.editMobileDesc2}
                            </Typography>
                        </DialogContentText>
                        <TextField
                            fullWidth
                            variant="outlined"
                            placeholder={Translate.mobileSample}
                            margin="normal"
                            value={mobile}
                            onChange={(e) => this.setState({mobile: e.target.value})}
                            label={Translate.mobile}
                        />
                    </DialogContent>
                    <DialogActions style={{justifyContent:"flex-end"}}>
                        <Button
                            onClick={() => this.handleSend()}
                            color="primary"
                            variant="outlined"
                            startIcon={submit_loading ? <CircularProgress size={20}/> : <EditRoundedIcon/>}
                        >
                            {Translate.save}
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(ChangeMobileModal)))));